export const environment = {
  apiBasePath: 'http://localhost:14000',
  production: false,
};
